import { ReactNode } from 'react';

type BadgeColor = 'blue' | 'green' | 'red' | 'amber' | 'gray' | 'violet';

const colorClasses: Record<BadgeColor, string> = {
    blue: 'bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-300',
    green: 'bg-emerald-100 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-300',
    red: 'bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-300',
    amber: 'bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-300',
    gray: 'bg-gray-100 text-gray-600 dark:bg-gray-800 dark:text-gray-300',
    violet: 'bg-violet-100 text-violet-700 dark:bg-violet-900/30 dark:text-violet-300',
};

/**
 * Badge / Tag — remplace antd Tag.
 */
const Badge = (props: { color?: BadgeColor; children: ReactNode; className?: string }) => (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-md text-xs font-semibold ${colorClasses[props.color || 'blue']} ${props.className || ''}`}>
        {props.children}
    </span>
);

export default Badge;
